import React, {PropTypes} from 'react';
import {I18N} from '../../../globals/config';
import {LOGIN_STEP} from '../join-modal';

const JoinFooter = ( props ) =>{
	return (
		<footer>

			<h5>
				{I18N.already_account}&nbsp;
				<a onClick={props.changeStep} data-step={LOGIN_STEP}>
					{I18N.sign_in}
				</a>
			</h5>
			<p>
				{I18N.subscriptions.join_now_desc}
			</p>
		</footer>
	)
};


JoinFooter.propTypes = {
	changeStep : PropTypes.func.isRequired
};

export default JoinFooter;



// WEBPACK FOOTER //
// ./src/components/modals/join/join-footer.js